import { MODAL_LOGIN } from '@config/globalModals.js'
import {
  getCurrentInstance,
  onBeforeUnmount,
  onDeactivated,
  readonly,
  ref,
} from 'vue'

const globalModalState = ref([])

// Number of open useModal instances, the body scroll lock is only released
// once the last one closes
let openModalCount = 0

export const globalModals = readonly(globalModalState)

export function setGlobalModal({ modal, data } = {}) {
  if (!modal) return
  globalModalState.value.push({ modal, data })
}

export function clearGlobalModal() {
  globalModalState.value = []
}

export function closeGlobalModal() {
  globalModalState.value.pop()
}

export function updateGlobalModalData(newData) {
  if (globalModalState.value.length) {
    globalModalState.value[globalModalState.value.length - 1].data = newData
  }
}

export default function useModal() {
  const state = ref(false)

  function showModal() {
    if (!state.value) openModalCount++
    state.value = true
    _addBodyClass()
  }

  function hideModal() {
    if (state.value) openModalCount--
    state.value = false
    if (openModalCount <= 0) {
      openModalCount = 0
      _removeBodyClass()
    }
  }

  const triggerModal = () => {
    state.value === true ? hideModal() : showModal()
  }

  function _addBodyClass() {
    document.body.classList.add('tw-overflow-hidden')
  }

  function _removeBodyClass() {
    document.body.classList.remove('tw-overflow-hidden')
  }

  // Release this instance's scroll lock if its component goes away while open
  if (getCurrentInstance()) {
    onBeforeUnmount(() => state.value && hideModal())
    onDeactivated(() => state.value && hideModal())
  }

  function showUserLogin() {
    setGlobalModal({ modal: MODAL_LOGIN })
  }

  return {
    isModalOpen: readonly(state),
    showUserLogin,
    triggerModal,
    showModal,
    hideModal,
  }
}
